import React, { useEffect, useState } from 'react';
import { CloseButton } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAddNewWipWorkFlowMutation, useAddNewClosedWorkFlowMutation } from "../../..//../../Services/campaign/CampaignMapping";
import { useTeamsQuery } from '../../../../../Services/settingsAPIs/CommonAPI';
import { toast } from 'react-toastify';

interface IProps {
  closeModal: () => void;
  workflowSelected: any // Consider defining a more specific type here.
  refetch: () => any;
  theTeams: any

}

const AddNewWipModal: React.FC<IProps> = ({ closeModal, workflowSelected, refetch, theTeams }) => {
  const initialValues = {
    name: '',
  };
  const [triggeerAddWip] = useAddNewWipWorkFlowMutation();

  const [triggeerAddClosed] = useAddNewClosedWorkFlowMutation();


  const validationSchema = Yup.object({
    name: Yup.string().required('Status title is required'),
  });
  const [statusType, setStatusType] = useState('progress');
  const [selectedTeam, setSelectedTeam] = useState<any>(null)
  const [selectedAssigntypeIsRR, setSelectedAssigntypeIsRR] = useState<boolean>(false)

  const toggleStatusType = (evt: any) => { evt.target.checked ? setStatusType('closed') : setStatusType('progress') }

  const handleTeamDropdownChange = (evt: any) => { setSelectedTeam(Number(evt.target.value)) }


  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const payload = {
        "assignment_team": selectedTeam,
        "visibility_team": selectedTeam,
        campaign_name: workflowSelected,
        status: values.name,
        "round_robin": selectedAssigntypeIsRR,
        "FIFO": false

      };

      try {
        let response;
        if (statusType === 'closed') {
          response = await triggeerAddClosed({ body: payload });
        } else {
          response = await triggeerAddWip({ body: payload });
        }

        if (response && response.error) {
          toast.error(response?.error?.data?.status_name[0] ?? "Failed to add stage. Please try again.");
          return;
        }else{
          await refetch();
          closeModal();
          toast.success("Stage added successfully");
        }

   
      } catch (error) {
        console.error('Error saving WIP:', error);
        toast.error("Failed to add stage. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  // useEffect(() => {
  //   setTheTeams(data)

  // }, [data]);
  return (
    <div>
      <div className="text-end">
        <CloseButton onClick={closeModal} />
      </div>

      <div >
        <div className="d-flex">
          <label className="form-check-label pe-2" htmlFor="flexSwitchCheckDefault">Toggle stage type: <strong>In progress</strong></label>
          <div className="form-check form-switch">
            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onChange={toggleStatusType} />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault"><strong>Closed</strong></label>
          </div>
        </div>
        <div className="text-start mt-4">
          <label className={`form-label fs-2 fw-bolder card-title d-flex ${statusType === 'progress' ? 'text-danger' : 'text-warning'}`}>
            <i className="bi bi-plus-lg fs-2x text-dark me-2"></i> in {statusType} stage
          </label>
        </div>
      </div>

      <form
        className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
        noValidate
        onSubmit={formik.handleSubmit}
      >

        <div className="row g-5 g-xl-8 mb-6">
          <div className="col-xl-6">
            <div className="d-flex flex-column">
              <label className="required">Add a stage title</label>
              <input
                id="name"
                name="name"
                type="text"
                className="form-control"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.name}
              />

              {formik.touched.name && formik.errors.name && (
                <div className="fv-plugins-message-container text-danger">
                  <span role="alert">{formik.errors.name}</span>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-6">
            <label>Select team</label>
            <select
              className="form-select select2-hidden-accessible"
              name="assignment_team"
              onChange={handleTeamDropdownChange}
              value={selectedTeam}

            >
              <option value="">Select team</option>
              {theTeams && theTeams.map((theTeam) => (<option value={theTeam.id}>{theTeam.name}</option>))}
            </select>

          </div>
        </div>
        <div className="row g-5 g-xl-8 mb-6">
          {/*ticket name feed*/}
          <div className="col-xl-12">
            <div className="row row-cols-2">
              <div className="col"><input type="radio" name="assignmentType" value="individualassignment" id="indvassgn" className="form-check-input" /><label htmlFor="indvassgn" className="form-label ps-2">Individual Assignment</label></div>
              <div className="col"><input type="radio" name="assignmentType" value="roundrobin" id="roundrobin" className="form-check-input" /><label htmlFor="roundrobin" className="form-label ps-2">Round Robin</label></div>
              <div className="col"><input type="radio" name="assignmentType" value="activelogins" id="activelgn" className="form-check-input" /><label htmlFor="activelgn" className="form-label ps-2">Active Logins(RR)</label></div>
              <div className="col"><input type="radio" name="assignmentType" value="teamassignment" id="teamassgn" className="form-check-input" /><label htmlFor="teamassgn" className="form-label ps-2">Team Assignment</label></div>
            </div>
          </div>
        </div>

        <div className="text-end mt-6 mb-4">
          <button
            className={`btn btn-sm btn-primary`}
            type="submit"
            disabled={formik.isSubmitting}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddNewWipModal;